export const combineDataToUniqueArray = (oldArray, data, propForCheck) => {
  if (!oldArray || !data || !propForCheck) {
    console.warn(
      'Combine data to unique array did not find the required data!',
    );
    return [];
  }
  const comboArrayWithDublicates = [...oldArray, ...data];
  const result = Array.from(
    new Set(comboArrayWithDublicates.map((a) => a[propForCheck])),
  ).map((id) => comboArrayWithDublicates.find((a) => a[propForCheck] === id));
  return result;
};

export const renderSphereObject = (id, categories) => {
  for (let i = 0; i < categories.data.length; i += 1) {
    if (categories.data[i].id === id) {
      return categories.data[i];
    }
  }
};

export const renderCastingCategoriesObject = (sphere, id) => {
  for (let i = 0; i < sphere.children.length; i += 1) {
    if (sphere.children[i].id === id) {
      return sphere.children[i];
    }
  }
};
